import type { ApiClient } from "../../api/api-client";
import type { HomeConversationSummary } from "../../api/types";

const FRESH_MS = 10_000;
const cache = new WeakMap<
  object,
  Map<string, { at: number; promise: Promise<HomeConversationSummary> }>
>();

/**
 * Load: the home widgets (waiting count, unassigned KPI, recent chats) share ONE
 * `conversations/home-summary` request per workspace instead of three list calls. A failed
 * request is not kept, so the next mount (or retry) asks again.
 */
export function loadHomeSummary(
  api: Pick<ApiClient, "getHomeConversationSummary">,
  workspaceId: string,
): Promise<HomeConversationSummary> {
  let byWorkspace = cache.get(api);
  if (!byWorkspace) cache.set(api, (byWorkspace = new Map()));
  const hit = byWorkspace.get(workspaceId);
  if (hit && Date.now() - hit.at < FRESH_MS) return hit.promise;
  const promise = api.getHomeConversationSummary(workspaceId);
  byWorkspace.set(workspaceId, { at: Date.now(), promise });
  promise.catch(() => {
    if (byWorkspace.get(workspaceId)?.promise === promise) byWorkspace.delete(workspaceId);
  });
  return promise;
}
